
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.9 13.707c0-.3 0-.5-.1-.7-.2-1.5-.6-2.9-1.3-4.1l1-1c.6-.6.2-3.7-.7-2.7l-1.8 1.8c-1.3-1.2-3-2-5.1-2-4.7-.2-7.9 4.1-7.9 8.7 0 1.8.5 3.5 1.3 4.9l-1 1c-.6.6-.2 3.7.7 2.7l1.8-1.8c1.2 1.2 2.8 1.9 4.7 2 4.9.3 7.8-3.7 8.3-8.1.1-.2.2-.4.1-.7zm-14.5 0c0-5.1 5.8-6.7 9.8-4.9l-8.4 8.4c-.9-.9-1.4-2.1-1.4-3.5zm3.3 4.9l8.4-8.4c.8.9 1.3 2 1.4 3.5-.2 4.9-6 6.6-9.8 4.9z"}})])
          )
        }
      }
    